export const addPeopleTranslations = {
    en: {
        addPeople: "Add People",
        searchPlaceholder: "Search people...",
        loading: "Loading...",
        noPeopleFound: "No people found",
        startTyping: "Start typing to search for people",
        selected: "Selected",
        people: "people",
        cancel: "Cancel",
        adding: "Adding...",
        addWithCount: "Add",
        fetchError: "Failed to fetch members. Please try again.",
        addError: "Failed to add members to group. Please try again.",
    },
    de: {
        addPeople: "Personen hinzufügen",
        searchPlaceholder: "Personen suchen...",
        loading: "Wird geladen...",
        noPeopleFound: "Keine Personen gefunden",
        startTyping: "Beginnen Sie zu tippen, um nach Personen zu suchen",
        selected: "Ausgewählt",
        people: "Personen",
        cancel: "Abbrechen",
        adding: "Wird hinzugefügt...",
        addWithCount: "Hinzufügen",
        fetchError: "Mitglieder konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.",
        addError: "Mitglieder konnten nicht zur Gruppe hinzugefügt werden. Bitte versuchen Sie es erneut.",
    },
    hr: {
        addPeople: "Dodaj osobe",
        searchPlaceholder: "Pretraži osobe...",
        loading: "Učitavanje...",
        noPeopleFound: "Nema pronađenih osoba",
        startTyping: "Počnite tipkati za pretragu osoba",
        selected: "Odabrano",
        people: "osoba",
        cancel: "Odustani",
        adding: "Dodavanje...",
        addWithCount: "Dodaj",
        fetchError: "Neuspješno dohvaćanje članova. Pokušajte ponovno.",
        addError: "Neuspješno dodavanje članova u grupu. Pokušajte ponovno.",
    },
};
